export default __webpack_public_path__ + "numbered-list.png";